import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import { saveAs } from "file-saver";

import Icon from "./Icon";
import autoTable from "jspdf-autotable";
import logo from "../assets/images/logo.jpg";
import { IRANSans } from "../utils/fonts";
import { convertDate } from "../utils";
import {
  convertBulkSMSTypeToText,
  convertDiscountCodeTypeToText,
  convertFieldTypeToText,
  convertInvoiceStatusToText,
  convertInvoiceTypeToText,
  convertLogMethodToText,
  convertOrderStatusToText,
  convertPaymentGatewayToText,
  convertPaymentStatusToText,
  convertProductTypeToText,
  convertRoleToText,
  convertTicketTypeToText,
  convertTransactionTypeToText,
} from "../utils/enum";
import { useSelector } from "react-redux";

const convertBoolean = (value) => (value ? "✅" : "❌");

const DataExporter = ({ headers, keys, data, fileName = "output" }) => {
  const auth = useSelector((state) => state.auth);

  if (!auth.isAdmin) return null;

  const extractData = (item, key) => {
    let value = key
      .split(".")
      .reduce((obj, k) => (obj && obj[k] !== undefined ? obj[k] : ""), item);

    if (typeof value === "boolean") return convertBoolean(value);
    else if (["expiredAt", "createdAt", "updatedAt"].includes(key))
      return convertDate(value, "YYYY MMM DD ساعت HH:mm:ss");

    value = convertTransactionTypeToText(value);
    value = convertTicketTypeToText(value);
    value = convertRoleToText(value);
    value = convertLogMethodToText(value);
    value = convertFieldTypeToText(value);
    value = convertProductTypeToText(value);
    value = convertOrderStatusToText(value);
    value = convertInvoiceStatusToText(value);
    value = convertPaymentStatusToText(value);
    value = convertInvoiceTypeToText(value);
    value = convertDiscountCodeTypeToText(value);
    value = convertBulkSMSTypeToText(value);
    value = convertPaymentGatewayToText(value);

    return value || "-";
  };

  const generateExcel = () => {
    const sheetData = [
      headers,
      ...data.map((item) => keys.map((key) => extractData(item, key))),
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    worksheet["!cols"] = headers.map(() => ({ wch: 20 }));

    Object.keys(worksheet).forEach((key) => {
      if (key.startsWith("A") || key.startsWith("B") || key.startsWith("C")) {
        worksheet[key].s = { alignment: { horizontal: "right" } };
      }
    });
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const excelFile = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(excelFile, `${fileName}.xlsx`);
  };

  const generatePDF = () => {
    const doc = new jsPDF({
      orientation: "p",
      unit: "mm",
      format: "a4",
    });

    doc.addFileToVFS("IRANSans.ttf", IRANSans);
    doc.addFont("IRANSans.ttf", "IRANSans", "normal");

    doc.setFont("IRANSans");
    doc.setFontSize(10);
    doc.addImage(logo, "JPG", 14, 10, 15, 15);
    doc.text("نت بوف", 184, 18, { align: "left" });

    const tableData = data.map((item) =>
      keys.map((key) => extractData(item, key)).reverse(),
    );

    autoTable(doc, {
      head: [headers.reverse()],
      body: tableData,
      them: "grid",
      startY: 25,
      margin: { top: 10 },
      styles: {
        font: "IRANSans",
        fontSize: 10,
        cellWidth: "auto",
        halign: "right",
        valign: "middle",
        cellPadding: 2,
      },
      headStyles: {
        font: "IRANSans",
        fontSize: 10,
        fillColor: [0, 0, 0],
        textColor: [255, 255, 255],
        halign: "right",
        valign: "middle",
        cellPadding: 5,
        fontStyle: "normal",
        cellWidth: "auto",
      },
      columnStyles: {
        0: { cellWidth: "wrap" },
      },
    });

    doc.save(`${fileName}.pdf`);
  };

  return (
    <div className="d-flex gap-2">
      <Icon
        onClick={generateExcel}
        icon="vscode-icons:file-type-excel"
        className="cursor-pointer text-2xxl"
      />
      <Icon
        onClick={generatePDF}
        icon="vscode-icons:file-type-pdf2"
        className="cursor-pointer text-2xxl"
      />
    </div>
  );
};

export default DataExporter;
